import { Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular-boost';
import { AsyncSubject, Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { IProfile } from '../interfaces/graph-types';

@Injectable()
export class ProfileService {
  loading: boolean = true;
  res: any;
  private _profile: AsyncSubject<IProfile>;

  // ------------------------------------------------------
  constructor(private apollo: Apollo) {
    this._profile = new AsyncSubject<IProfile>();

    this.profile(80).subscribe(response => {
      this.setProfile(response);
    });
  }

  // ------------------------------------------------------
  public myProfile(): AsyncSubject<IProfile> {
    return this._profile;
  }

  // ------------------------------------------------------
  public setProfile(data: IProfile) {
    this._profile.next(data);
    this._profile.complete();
  }

  // ------------------------------------------------------
  public profile(size: number): Observable<IProfile> {
    return this.apollo
      .watchQuery<{ profile: IProfile }>({
        query: gql`
        query myProfile {
          profile {
            id
            firstName
            email
            avatarUrl(size: ${size})
            admin

            organizations {
              id
              name
              domain
            }
          }
        }
      `,
        fetchPolicy: 'no-cache',
        notifyOnNetworkStatusChange: false,
      })
      .valueChanges.pipe(
        map(({ data }) => data.profile),
        startWith(null),
      );
  }
}
